export default "__VITE_ASSET__9M5q_Ce___"